import { ga4Push } from '../helper/ga4-utilities';

export class DealMeasurements {

    /**
     * initializes the home page measurements
     * @param {jQuery} container
     */
    constructor(container) {
        this.container = container;
        this.init();
    }

    init() {
        this.initMapMeasurement();
        this.initGalleryMeasurement();
        this.initShowMoreMeasurement();
        this.initHotelClickMeasurement();
        this.initCatalogClickMeasurement();
        this.initSimilarOfferMeasurement();
    }

    getContainer() {
        if (this.container.length === 0) {
            console.error('Page container not found');
        }

        return this.container;
    }

    initMapMeasurement() {
        this.getContainer()
        .find('.map-toggle-measurement')
        .on('click.mapClick', (event) => {
            ga4Push({
                event: 'view_details',
                content_type: 'map_link',
            });
        });
    }

    initGalleryMeasurement() {
        this.getContainer()
        .find('.deal-carousel')
        .find('.carousel-item')
        .on('click.galleryClick', (event) => {
            ga4Push({
                event: 'gallery_open',
            });
        });
    }

    initShowMoreMeasurement() {
        this.getContainer()
        .find('.show-more-text')
        .on('click.showMoreClick', (event) => {
            const nameOfHotel = $(event.currentTarget).data('hotel-name');

            ga4Push({
                event: 'view_details',
                content_type: `${nameOfHotel} details`,
            });
        });
    }

    initHotelClickMeasurement() {
        this.getContainer()
        .find('.choosable-hotels')
        .find('.deal-box')
        .on('click.choseHotelClick', (event) => {
            const nameOfHotel = $(event.currentTarget).closest('.deal-box').find('img').attr('alt');
            const nameOfExperiencePackage = this.getContainer().find('.package-title').html();

            ga4Push({
                event: 'view_details',
                content_type: `${nameOfExperiencePackage} - ${nameOfHotel}`,
            });
        });
    }

    initCatalogClickMeasurement() {
        this.getContainer()
        .find('.catalog-link')
        .on('click.catalogClick', (event) => {
            const nameOfExperiencePackage = this.getContainer().find('.package-title').html();

            ga4Push({
                event: 'view_details',
                content_type: `${nameOfExperiencePackage}`,
            });
        });
    }

    initSimilarOfferMeasurement() {
        this.getContainer()
        .find('.similar-offers-swiper')
        .find('.deal-box')
        .on('click.similarOfferClick', (event) => {
            const ga4dataToSend = $(event.currentTarget).data('ga4data');
            if (ga4dataToSend !== null) {
                ga4Push({
                    event: 'select_item',
                    item_list_name: ga4dataToSend.item_list_name,
                });
            }
        });
    }

}
